import React, { useState, useEffect } from 'react';
import './MetricDateRangeSelector.css';

function MetricDateRangeSelector({ user, onChange }) {
  const dateRanges = [
    { value: '0',   label: 'Current Usage' },
    { value: '1',   label: 'Today' },
    { value: '7',   label: 'Last 7 days' },
    { value: '30',  label: 'Last 30 days' },
    { value: '90',  label: 'Last 90 days' },
    { value: '180', label: 'Last 180 days' },
    { value: '365', label: 'Last year' },
  ];
  const [options, setOptions] = useState([]);
  const [selectedRange, setSelectedRange] = useState('0');

  useEffect(() => {
    setOptions(dateRanges);
    if (user?.dateRange) {
      setSelectedRange(user.dateRange);
    }
  }, [user]);

  const handleRangeChange = (e) => {
    const value = e.target.value;
    setSelectedRange(value);
    onChange(e);
  };

  return (
    <div className="metric-range-selector-container">
      <span className="metric-name">Select Time Range</span>
      <select
        data-say-id="metric-time-range-selector"
        className="metric-range-selector"
        value={selectedRange}
        onChange={handleRangeChange}
      >
        {options.map((opt, idx) => (
          <option key={idx} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default MetricDateRangeSelector;
